<template>
  <div
    tabindex="0"
    class="columns disable-outline is-justify-content-center is-gapless"
    @keydown.esc="closeIframe"
  >
    <div
      ref="bookmarks-column"
      class="column bookmarks-column loading-data"
      :class="[viewerOn ? 'is-5' : 'is-12']"
    >
      <BookmarkListToolbar
        :default-view="cardType"
      />
      <transition-group
        name="bookmark-card-holder"
        tag="div"
        class="columns is-multiline is-mobile"
      >
        <component
          :is="currentView"
          v-for="(bookmark, index) in bookmarks"
          :ref="'bookmark-'+bookmark.id"
          :key="bookmark.id"
          :bookmark="bookmark"
          :index="index"
          :selected-tags="selectedTags"
          :tags-names="tagsNames"
          class="bookmark-card-holder"
          :class="{selected: (viewerBookmark.id == bookmark.id)}"
          @tagClicked="addTag"
          @editRecord="editRecord"
          @confirmDeleted="confirmDelete"
          @deletedSelected="deleteSelected"
          @openUrlInFrame="openUrlInFrame"
          @reparse="reparse"
          @wayback="wayback"
        />
      </transition-group>
    </div>
    <div
      :class="[viewerOn ? 'is-7' : 'is-0']"
      class="column qlipmark-iframe-column"
    >
      <div
        v-if="viewerOn"
        class="qlipmark-iframe-card sticky"
        :class="{ 'qlipmark-iframe-card--full': !showNavbar }"
      >
        <div class="bookmark-card break-word iframe-toolbar">
          <div class="columns is-mobile is-gapless is-vcentered mb-0">
            <div class="column is-flex-grow-0">
              <b-button
                type="is-light is-stealth"
                icon-left="times-circle"
                @click="closeIframe"
              />
            </div>
            <div class="column is-grow-1">
              <div>
                <a
                  :href="viewerBookmark.url"
                  target="_blank"
                  class="card-header-title viewer-title"
                >
                  <img
                    :src="viewerBookmark.faviconUrl"
                    class="favicon"
                    @error="setPlaceholder"
                  >
                  {{ viewerBookmark.title }}
                </a>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <TagList
              :tags="tagsNames(viewerBookmark.tags)"
              :selected-tags="selectedTags"
              class="card-footer-item"
              @tagClicked="addTag"
            />

            <BookmarkActionsMenu
              :bookmark="viewerBookmark"
              @editRecord="editRecord"
              @confirmDeleted="confirmDelete"
              @deletedSelected="deleteSelected"
              @reparse="reparse"
              @wayback="wayback"
            />
          </div>
        </div>
        <div
          id="qlipmark-iframe-holder"
          class="qlipmark-iframe-holder"
        />
      </div>
    </div>

    <b-modal
      v-model="isBookmarkFormActive"
      :parent="$parent"
      :width="720"
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <template>
        <BookmarkForm
          :id="bookmarkFormId"
          :modal="true"
          @close="closeModal"
          @edited="editedEvent"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  // import { hiddingOnScroll } from '@/mixins/hiddingOnScroll'
  import { showMixin } from '@/mixins/crud/pagination'
  // import { ToastProgrammatic as Toast } from 'buefy'

  import BookmarkForm from '@/components/bookmarks/BookmarkForm.vue'
  import TagList from '@/qlipmark-shared/components/tags/TagList.vue'

  import BookmarkListToolbar from '@/components/bookmarks/BookmarkListToolbar.vue'

  import BookmarkCardRegular from '@/components/bookmarks/cards/Regular.vue'
  import BookmarkCardGrid from '@/components/bookmarks/cards/Grid.vue'
  import BookmarkCardCompact from '@/components/bookmarks/cards/Compact.vue'

  import BookmarkActionsMenu from '@/components/bookmarks/BookmarkActionsMenu.vue'

  export default {
    name: 'BookmarkCard',
    mixins: [ showMixin('bookmark') ],
    components: {
      BookmarkForm,
      TagList,
      BookmarkListToolbar,
      BookmarkCardRegular,
      BookmarkCardGrid,
      BookmarkCardCompact,
      BookmarkActionsMenu
    },
    props: ['bookmarks', 'selectedTags', 'cardType'],
    data: function() {
      return {
        isBookmarkFormActive: false,
        bookmarkFormId: '',
        viewerOn: false,
        editTagTo: false,
        viewerBookmark: {},
      }
    },
    computed: {
      ...mapGetters({
        bookmarkById: 'bookmarks/byId'
      }),
      currentView() {
        return `BookmarkCard${this.cardType}`
      }
    },
    watch: {
      viewerOn(val) {
        this.$emit('viewerChanged', val)
      }
    },
    methods: {
      ...mapActions({
        byId: 'bookmarks/byId',
        delete: 'bookmarks/delete',
        reparseBookmark: 'bookmarks/reparse',
        // waybackBookmark: 'bookmarks/wayback',
      }),
      tagsNames(tag_ids) {
        let that = this
        return tag_ids.map(id => {
            if (that.$store.state.tags.entities[id]) {
              return that.$store.state.tags.entities[id].name
            }
          }
        )
      },
      addTag(tag) {
        this.$emit('tagClicked', tag)
      },
      editRecord(id) {
        this.bookmarkFormId = id
        this.isBookmarkFormActive = true
      },
      closeModal() {
        this.isBookmarkFormActive = false
      },
      editedEvent(eventArgs) {
        this.$emit('edited', eventArgs);
      },
      confirmDelete(id) {
        showMixin().methods.confirmDelete.call(this, id)

        this.$buefy.dialog.confirm({
          title: 'Deleting Bookmark',
          message: `Are you sure you want to delete <b>"${this.bookmarkById(id).title}"</b>?`,
          confirmText: 'Delete',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.deleteSelected(id),
          onCancel: () => this.cancelSelected()
        })
      },
      deleteSelected(id) {
        this.delete([id])
      },
      reparse(id) {
        this.reparseBookmark(id)
      },
      wayback(bookmark) {
        const date = new Date(bookmark.updatedAt).toISOString().slice(0,10).replace(/-/g,"")
        window.open(`http://web.archive.org/web/${date}/${bookmark.url}`)
        // this.waybackBookmark(id).then(function(response){
        //   if (!response) {
        //     Toast.open({
        //       message: "Couldn't find a Wayback version of this url",
        //       position: 'is-bottom',
        //       type: 'is-danger'
        //     })
        //   } else {
        //     window.open(response, "_blank")
        //   }
        // })
      },
      openUrlInFrame(bookmark) {
        if (document.getElementById("qlipmark-extension-installed")) {
          this.viewerOn = true
          this.viewerBookmark = bookmark
          window.postMessage({type: "openUrlInFrame", url: bookmark.url}, "*")

          setTimeout(() => {
            const elem = this.$refs['bookmark-'+bookmark.id][0].$el
            const bounding = elem.getBoundingClientRect();
            if (
              bounding.top <= 0 ||
              bounding.top+bounding.height >= (window.innerHeight || document.documentElement.clientHeight)) {
              window.scrollTo({
                left: 0,
                top: elem.offsetTop-70
              })
            }
          }, 200)
        } else {
          alert('You need the qlipmark extension installed for previewing')
        }
      },
      closeIframe() {
        this.viewerOn = false

        const bookmark = this.viewerBookmark
        setTimeout(() => {
          const elem = this.$refs['bookmark-'+bookmark.id][0].$el
          const bounding = elem.getBoundingClientRect();
          if (
            bounding.top <= 0 ||
            bounding.top+bounding.height >= (window.innerHeight || document.documentElement.clientHeight)) {
            window.scrollTo({
              left: 0,
              top: elem.offsetTop-70,
            })
          }

          this.viewerBookmark = {}
        }, 200)
      },
      setPlaceholder(e) {
        e.target.classList.add('placeholder')
        e.target.src = "/images/defaults/globe-americas-solid.svg"
      },
    }
  }
</script>

<style lang="scss" scoped>
  .bookmark-card-holder-enter-active, .bookmark-card-holder-leave-active {
    transition: all 0.2s ease-out;
  }
  .bookmark-card-holder-enter, .bookmark-card-holder-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
    transform: scaleY(0%);
  }

  .column.bookmarks-column,
  .qlipmark-iframe-column {
    transition: all 0.2s ease-in-out;
  }

  .iframe-toolbar {
    border: 1px solid #ddd;
    border-top: 0px;
    border-left: 0px;
    box-shadow: 0px 1px 2px -2px #000;

    > .columns {
      width: 100%;
    }

    .card-header-title,
    .tags-list {
      margin: 4px;
      padding: 4px;
    }

    .tags-list {
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .favicon {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }

    .viewer-title {
      padding-right: 20px;
    }
  }
</style>
